/**
 * Toolkit JavaScript
 * This file was mentioned as "styleguide" but it's not !
 * Everything there is needed for mywort frontend app
 */
import stickit from "./sticky-header";
import dropdown from "./dropdown";
import infobox from "./infobox";
import search from "./search";
import sectionNavigation from "./section-navigation";
import collapse from "./collapse";

stickit.init('mywort-header-sticky', window);
dropdown.init(window);
infobox.init(window);
search.init();
collapse.init();
sectionNavigation.init('mywort-section-navigation');



// WEBPACK FOOTER //
// ./js/mywort/styleguide/styleguide.js